import React from "react";
import "./About.css";
import { TbDownload } from "react-icons/tb";
import resume from "../../assets/pdf/Pradip_Khamkar.pdf";
import Lottie from "lottie-react";
import aboutAnimation from "../../assets/Json/89960-developer.json";
import { BsSuitHeartFill } from "react-icons/bs";

const About = () => {
  return (
    <section className="about section" id="about">
      <h2 className="section__title">About Me</h2>
      <span className="section__subtitle">My introduction</span>
      <div className="about__container container grid">
        <Lottie animationData={aboutAnimation} className="about__img" />
        {/* <img src={about} alt="" className="" /> */}

        <div className="about__data">
          <p className="about__description">
            A passionate Full Stack Software Developer <br /> having an good
            knowleage of building Web Applications with JavaScript / Reactjs /
            Nodejs / Expressjs / MongoDB and some other cool libraries and
            frameworks. <br />
            <br />I Have Youtube Channel With 4K+ Subscriber Where I Provide
            Educational Related Content{" "}
            <i className="about__heart">
              <BsSuitHeartFill />
            </i>
          </p>
          <br />

          <div className="about__buttons">
            <a download="" href={resume} className="button button--flex">
              Download Resume{" "}
              <i className="button__icon send__icon">
                <TbDownload />
              </i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
